import Layout from '@/layout'

const noticeRouter = {
  path: '/notice',
  component: Layout,
  name: 'publicAnnouncement',
  meta: {
    title: 'routeReleaseManagement',
    icon: 'sjfb',
    code: 'release'

  },
  children: [
    {
      path: 'publicAnnouncement',
      component: () => import('@/views/notice/publicAnnouncement'),
      name: 'PublicAnnouncement',
      meta: { title: 'routePublicAnnouncement', icon: 'zlgg', code: 'notice:info:management' }
    },
    {
        path: 'knowledge',
        component: () => import('@/views/notice/knowledge'),
        name: 'Knowledge',
        meta: { title: 'routeKnowledge', icon: 'zsk', code: 'notice:knowledge:management' }
    },
    {
        path: 'marketDisposal',
        component: () => import('@/views/notice/marketDisposal'),
        name: 'MarketDisposal',
        meta: { title: 'routeMarketDisposal', icon: 'sccz', code: 'notice:event:management' }
    },
    {
        path: 'technicalCircular',
        component: () => import('@/views/notice/technicalCircular'),
        name: 'TechnicalCircular',
        meta: { title: 'routeTechnicalCircular', icon: 'jstg', code: 'notice:tech:management' }
    },
    {
      path: 'vehBom',
      component: () => import('@/views/notice/vehBom'),
      name: 'VehBom',
      meta: { title: 'routeVehBom', icon: 'vb', code: 'mes:boom' }
    },
    {
      path: 'vehCar',
      component: () => import('@/views/notice/vehCar'),
      name: 'VehCar',
      meta: { title: 'routeVehCar', icon: 'vb', code: 'vehicle:config:page' }
    },
    {
      path: 'spareParts',
      component: () => import('@/views/notice/spareParts'),
      name: 'SpareParts',
      meta: { title: 'routeSpareParts', icon: 'bjcf', code: 'notice:sparePartReploy:page' }
    },
    {
      path: 'criticalParts',
      component: () => import('@/views/notice/criticalParts'),
      name: 'CriticalParts',
      meta: { title: 'routeCriticalParts', icon: 'criticalParts', code: 'data:query:qualityCritical' }
    },

    // {
    //   path: 'loadBom',
    //   component: () => import('@/views/notice/loadBom'),
    //   name: 'LoadBom',
    //   meta: { title: 'routeLoadBom', icon: 'loadBom', code: 'data:query:bom' }
    // },
    {
      path: 'loginManagement',
      component: () => import('@/views/notice/loginManagement'),
      name: 'LoginManagement',
      meta: { title: 'routeLoginManagement', icon: 'loginmanagement', code: 'sys:login:log' }
    }
    // ,
    // {
    //   path: 'generalInfo',
    //   component: () => import('@/views/notice/generalInfo'),
    //   name: 'GeneralInfo',
    //   meta: { title: 'routeRepairGeneralInfo', icon: 'generalInfo', code: 'general:info:page' }
    // }
  ]
}

export default noticeRouter
